module.exports = __webpack_public_path__ + "media/images/hvdaktiv_gesundbox-79d8d34fd4622494a09492fa8872569d.jpg";